<ng-container *ngxPermissionsOnly="[role.organizationAdmin]">
  <div class="row row--info">
    <div class="col-sm-12">
      <button pButton [text]="true" size="small" (click)="close()">
        <i class="pi pi-angle-left"></i> Back
      </button>
    </div>
  </div>
</ng-container>

<div class="card-box">
  <app-page-title [content]="model.getFullName() || 'User'"></app-page-title>

  <div [formGroup]="form">
    <input type="hidden" formControlName="id" />

    <div class="row">
      <div class="col-xl-7 user-form__fields">
        <div class="row">
          <div class="col-md-6">
            <div class="form-field">
              <span class="form-control-label required">First Name</span>
              <input
                pInputText
                formControlName="firstName"
                class="form-control"
              />
            </div>

            <div class="form-field">
              <span class="form-control-label required">E-mail</span>
              <input pInputText formControlName="email" class="form-control" />
            </div>

            @if (loggedInUser?.hasCompanies()) {
              <div
                class="form-field"
                *ngxPermissionsOnly="[role.organizationAdmin]"
              >
                <span class="form-control-label">Company</span>
                <app-company-select
                  [company]="form.get('company').value"
                  (companyChange)="onCompanyChange($event)"
                >
                </app-company-select>
              </div>
            }

            <div class="form-field">
              <span class="form-control-label">Language</span>
              <app-language-select
                [showClear]="true"
                [language]="form.get('language').value"
                (languageChange)="onLanguageChange($event)"
              >
              </app-language-select>
            </div>

            @if (model.getId()) {
              <div
                class="form-field"
                *ngxPermissionsOnly="[role.organizationAdmin]"
              >
                <span class="form-control-label">Password</span>
                <app-password
                  (passwordChanged)="form.controls.password.setValue($event)"
                >
                </app-password>
              </div>
            }

            <div
              class="form-field"
              *ngxPermissionsExcept="[role.organizationAdmin]"
            >
              <app-user-form-password [user]="model"> </app-user-form-password>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-field">
              <span class="form-control-label required">Last Name</span>
              <input
                pInputText
                formControlName="lastName"
                class="form-control"
              />
            </div>

            <div
              class="form-field"
              *ngxPermissionsOnly="[role.organizationAdmin]"
            >
              <span class="form-control-label required">Team</span>
              @if (teamList.length) {
                <p-select
                  [options]="teamList"
                  formControlName="team"
                  dataKey="id"
                  [filter]="true"
                  filterBy="label, value"
                >
                </p-select>
              }
            </div>

            <div
              class="form-field"
              *ngxPermissionsOnly="[role.organizationAdmin]"
            >
              <span class="form-control-label required">Role</span>
              <app-user-group-select
                [selectedUserGroups]="form.get('groups').value"
                (userGroupsChange)="onUserGroupsChange($event)"
              >
              </app-user-group-select>
            </div>

            <div class="form-field">
              <span class="form-control-label">Phone / Address</span>
              <i
                class="pi pi-info-circle"
                pTooltip="If this field is updated, it will be visible on the offer"
                tooltipPosition="right"
              >
              </i>
              <textarea
                pInputText
                class="form-control"
                formControlName="phone"
                placeholder="Phone / Address"
              ></textarea>
            </div>

            <div
              class="form-field"
              *ngxPermissionsOnly="[role.organizationAdmin]"
            >
              <!-- Empty label line so the checkboxes centre against the
                   Password field opposite them in the left column. -->
              <span class="form-control-label" aria-hidden="true">&nbsp;</span>

              <div class="checkbox-row">
                @if (model.getId()) {
                  <span class="checkbox-field">
                    <p-checkbox
                      [formControl]="form.controls.enabled"
                      binary="true"
                      inputId="user-enabled"
                    >
                    </p-checkbox>
                    <label class="form-control-label" for="user-enabled"
                      >Active</label
                    >
                  </span>
                }

                <span class="checkbox-field">
                  <p-checkbox
                    [formControl]="form.controls.limitedCrm"
                    binary="true"
                    inputId="user-limited-crm"
                  >
                  </p-checkbox>
                  <label class="form-control-label" for="user-limited-crm"
                    >Limited CRM</label
                  >
                  <i
                    class="pi pi-info-circle"
                    pTooltip="User can not add a new account and can not edit account detail"
                    tooltipPosition="right"
                  >
                  </i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-5 user-form__integration">
        <app-user-form-email [form]="form" [user]="model">
        </app-user-form-email>
        @if (loggedInUser && model.getId() === loggedInUser.getId()) {
          <div class="user-form__integration-section">
            <app-user-form-ai-assistant></app-user-form-ai-assistant>
          </div>
        }
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <span class="form-control-label">Email signature</span>
        <app-wysiwyg
          (valueChanged)="updateSignature($event)"
          [value]="model.getSignature()"
        >
        </app-wysiwyg>
      </div>
    </div>
  </div>

  <div class="user-footer">
    <div class="footer-actions">
      <div class="footer-actions-start">
        <ng-container *ngxPermissionsOnly="[role.superAdmin]">
          @if (model.getId()) {
            <button
              pButton
              [text]="true"
              severity="danger"
              size="small"
              (click)="delete(model)"
            >
              <i class="pi pi-trash"></i> Delete
            </button>
          }
        </ng-container>
        <ng-container *ngxPermissionsOnly="[role.superAdmin]">
          @if (model.getId()) {
            <button
              pButton
              [text]="true"
              size="small"
              (click)="impersonate(model)"
            >
              <i class="pi pi-user"></i> Impersonate
            </button>
          }
        </ng-container>
      </div>

      <div class="footer-actions-end">
        <span class="footer-divider" aria-hidden="true"></span>

        <button pButton [disabled]="form.invalid" (click)="saveOrAdd(true)">
          <i
            class="pi"
            [class.pi-save]="model && model.id"
            [class.pi-plus]="!(model && model.id)"
          ></i>
          {{ model && model.id ? "Save" : "Add" }}
        </button>
      </div>
    </div>
  </div>
</div>
